import { generateClient, post } from "aws-amplify/api";

const client = generateClient();

export async function requestCreateNPWPDraft(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_NPWP_DRAFT" });
    const { input, userID } = payload;
    const request = await client.graphql({
      query: createNPWPDraft,
      variables: { input },
    });
    const npwpDraft = request.data.createNPWPDraft;
    const userInput = {
      id: userID,
      npwpDraftID: npwpDraft.id,
    };
    // eslint-disable-next-line no-unused-vars
    const requestUser = await client.graphql({
      query: updateUser,
      variables: { input: userInput },
    });
    dispatch({ type: "UPDATE_USER_NPWP_DRAFT", payload: { npwpDraft } });
    dispatch({ type: "SUCCESS_CREATE_NPWP_DRAFT", payload: { npwpDraft } });
  } catch (error) {
    dispatch({ type: "ERROR_CREATE_NPWP_DRAFT", error });
  }
}

export async function requestUpdateNPWPDraft(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_UPDATE_NPWP_DRAFT" });
    const { userID, input, silent } = payload;

    const request = await client.graphql({
      query: updateNPWPDraft,
      variables: { input },
    });
    const npwpDraft = request.data.updateNPWPDraft;
    const userInput = {
      id: userID,
      npwpDraftID: npwpDraft.id,
    };
    // eslint-disable-next-line no-unused-vars
    const requestUser = await client.graphql({
      query: updateUser,
      variables: { input: userInput },
    });
    dispatch({ type: "UPDATE_USER_NPWP_DRAFT", payload: { npwpDraft } });
    dispatch({
      type: "SUCCESS_UPDATE_NPWP_DRAFT",
      payload: { npwpDraft, silent },
    });
  } catch (error) {
    dispatch({ type: "ERROR_UPDATE_NPWP_DRAFT", error });
  }
}

export async function requestRegisterNPWP(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_REGISTER_NPWP",
      payload: { request: null },
    });

    const { input, userID, silent } = payload;
    const requestDraft = await client.graphql({
      query: updateNPWPDraft,
      variables: { input },
    });
    const npwpDraft = requestDraft.data.updateNPWPDraft;
    const userInput = {
      id: userID,
      npwpDraftID: npwpDraft.id,
    };
    // eslint-disable-next-line no-unused-vars
    const requestUser = await client.graphql({
      query: updateUser,
      variables: { input: userInput },
    });
    dispatch({ type: "UPDATE_USER_NPWP_DRAFT", payload: { npwpDraft } });
    dispatch({
      type: "SUCCESS_UPDATE_NPWP_DRAFT",
      payload: { npwpDraft, silent },
    });

    const isLocalhost = Boolean(
      window.location.hostname === "localhost" ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === "[::1]" ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
          /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    const isDev = Boolean(
      window.location.hostname === "web-user-v2-pajakind.vercel.app"
    );

    const bypass = isLocalhost || isDev;

    const request = post({
      apiName: "npwp",
      path: "/register",
      options: {
        body: { bypass },
      },
    });
    dispatch({
      type: "REQUEST_REGISTER_NPWP",
      payload: { request },
    });
    const { body } = await request.response;

    const res = await body.json();

    dispatch({
      type: "REQUEST_REGISTER_NPWP_SUCCESS",
      payload: { registeredNpwpID: res.data.id },
    });
  } catch (error) {
    dispatch({ type: "REQUEST_REGISTER_NPWP_ERROR", error });
  }
}

export async function clearUpdateNPWPDraft(dispatch) {
  dispatch({ type: "CLEAR_UPADTE_NPWP_DRAFT" });
}

export async function clearRegisterNPWP(dispatch) {
  dispatch({ type: "CLEAR_REGISTER_NPWP" });
}

export async function requestGetNPWPStatus(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_GET_NPWP_STATUS", payload: { request: null } });

    const { npwp = "", nik = "" } = payload;
    const params = {};
    if (npwp) {
      params.npwp = npwp;
    }
    if (nik) {
      params.nik = nik;
    }

    const request = post({
      apiName: "npwp",
      path: "/status",
      options: {
        body: params,
      },
    });
    dispatch({ type: "REQUEST_GET_NPWP_STATUS", payload: { request } });

    const { body } = await request.response;

    const res = await body.json();

    dispatch({
      type: "GET_NPWP_STATUS_SUCCESS",
      payload: { npwp: res.data },
    });
  } catch (error) {
    dispatch({ type: "GET_NPWP_STATUS_ERROR", error });
  }
}

export async function requestListNPWPUsage(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_NPWP_USAGE", payload: { request: null } });

    const { userID } = payload;

    let items = [];
    let nextToken = "start";

    while (nextToken) {
      const params = { userID, limit: 20 };
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const request = client.graphql({
        query: npwpQuotaUsagesByUser,
        variables: params,
      });
      dispatch({ type: "REQUEST_LIST_NPWP_USAGE", payload: { request } });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.npwpQuotaUsagesByUser.items];
      nextToken = res.data.npwpQuotaUsagesByUser.nextToken;
    }

    const usage = items.reduce((acc, item) => {
      return acc + item.usage;
    }, 0);

    dispatch({ type: "LIST_NPWP_USAGE_SUCCESS", payload: { usage } });
  } catch (error) {
    dispatch({ type: "LIST_NPWP_USAGE_ERROR", error });
  }
}

const npwpQuotaUsagesByUser = /* GraphQL */ `
  query NpwpQuotaUsagesByUser(
    $userID: ID
    $usage: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNPWPQuotaUsageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    npwpQuotaUsagesByUser(
      userID: $userID
      usage: $usage
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        usage
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createNPWPDraft = /* GraphQL */ `
  mutation CreateNPWPDraft($input: CreateNPWPDraftInput!) {
    createNPWPDraft(input: $input) {
      id
      taxCategory
      mainNPWP
      isMain
      name
      gender
      phone
      cellPhone
      countryCode
      identityId
      familyId
      foreignerIdentityId
      birthPlace
      birthDate
      marriageStatus
      husbandCountryCode
      husbandPassport
      totalDependant
      incomeLevel
      street
      block
      streetNumber
      rtNumber
      rwNumber
      regionCode
      idStreet
      idBlock
      idStreetNumber
      idRtNumber
      idRwNumber
      idRegionCode
      businessStreet
      businessBlock
      businessStreetNumber
      businessRtNumber
      businessRwNumber
      businessRegionCode
      businessPhone
      businessCellPhone
      employeeCode
      employeeDescription
      businessCode
      businessDescription
      businessName
      businessBookeeping
      businessHasEmployee
      businessBookeepingStart
      businessBookeepingEnd
      freelanceCode
      freelanceDescription
      freelanceName
      freelanceBookeeping
      freelanceHasEmployee
      freelanceBookeepingStart
      freelanceBookeepingEnd
      otherCode
      otherDescription
      createdAt
      updatedAt
    }
  }
`;

const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      npwpDraftID
      npwpDraft {
        id
        taxCategory
        mainNPWP
        isMain
        name
        gender
        phone
        cellPhone
        countryCode
        identityId
        familyId
        foreignerIdentityId
        birthPlace
        birthDate
        marriageStatus
        husbandCountryCode
        husbandPassport
        totalDependant
        incomeLevel
        street
        block
        streetNumber
        rtNumber
        rwNumber
        regionCode
        idStreet
        idBlock
        idStreetNumber
        idRtNumber
        idRwNumber
        idRegionCode
        businessStreet
        businessBlock
        businessStreetNumber
        businessRtNumber
        businessRwNumber
        businessRegionCode
        businessPhone
        businessCellPhone
        employeeCode
        employeeDescription
        businessCode
        businessDescription
        businessName
        businessBookeeping
        businessHasEmployee
        businessBookeepingStart
        businessBookeepingEnd
        freelanceCode
        freelanceDescription
        freelanceName
        freelanceBookeeping
        freelanceHasEmployee
        freelanceBookeepingStart
        freelanceBookeepingEnd
        otherCode
        otherDescription
      }
    }
  }
`;

const updateNPWPDraft = /* GraphQL */ `
  mutation UpdateNPWPDraft($input: UpdateNPWPDraftInput!) {
    updateNPWPDraft(input: $input) {
      id
      taxCategory
      mainNPWP
      isMain
      name
      gender
      phone
      cellPhone
      countryCode
      identityId
      familyId
      foreignerIdentityId
      birthPlace
      birthDate
      marriageStatus
      husbandCountryCode
      husbandPassport
      totalDependant
      incomeLevel
      street
      block
      streetNumber
      rtNumber
      rwNumber
      regionCode
      idStreet
      idBlock
      idStreetNumber
      idRtNumber
      idRwNumber
      idRegionCode
      businessStreet
      businessBlock
      businessStreetNumber
      businessRtNumber
      businessRwNumber
      businessRegionCode
      businessPhone
      businessCellPhone
      employeeCode
      employeeDescription
      businessCode
      businessDescription
      businessName
      businessBookeeping
      businessHasEmployee
      businessBookeepingStart
      businessBookeepingEnd
      freelanceCode
      freelanceDescription
      freelanceName
      freelanceBookeeping
      freelanceHasEmployee
      freelanceBookeepingStart
      freelanceBookeepingEnd
      otherCode
      otherDescription
    }
  }
`;
